import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import React from 'react';
import i18n from 'i18next';
import { Modal, message, Button, Form, Radio } from 'antd';
import { Input, Row, Col, Select, DatePicker, ConfigProvider } from 'antd';
import { apis } from '../api/index.js';
import { getInstitutionOptions, formatDate, getProjectOption } from '../utils';
import { institutionRecord, getArea, instProjectInfo } from '../utils';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import moment from 'moment';
const { TextArea } = Input;
const { Option } = Select;

class InstitutionAdd extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    form: PropTypes.object,
    institutionInfo: PropTypes.object,
    detailType: PropTypes.string,
    institutionData: PropTypes.array,
    history: PropTypes.object,
  };

  state = {
    visible: this.props.visible,
    confirmLoading: false,
    status: 0,
    provinceList: [],
    cityList: [],
    districtList: [],
    cityVisible: true,
    institutionData: [],
    productList: [],
    i18nextLng: 'zh-CN',
    projectList: [],
  };
  componentDidUpdate(prevProps) {
    const { visible, detailType, institutionInfo } = this.props;
    if (prevProps.visible !== visible) {
      this.setState({ visible });
      if (visible) {
        this.props.form.resetFields();
        //上级机构列表
        this.getInstitutionData();
        if (detailType === 'detail' || detailType === 'update') {
          this.getArea(0, 'province'); //获取省份
          const provinceCode = institutionInfo.areaProvince;
          const cityCode = institutionInfo.areaCity;
          const provinceArray = [110000, 120000, 500000, 310000];
          if (provinceArray.indexOf(provinceCode) >= 0) {
            this.setState({ cityVisible: false });
            this.getArea(provinceCode, 'district'); //根据省份id获取直辖市列表
          } else {
            this.setState({ cityVisible: true });
            this.getArea(provinceCode, 'city'); //根据省份id获取城市列表
            this.getArea(cityCode, 'district');
          }
        }

        if (visible) this.getInstProjectInfo();
      }
    }
  }

  //获取项目列表
  getInstProjectInfo = async () => {
    const res = await instProjectInfo();
    this.setState({ projectList: res.list });
  };

  getArea = async (id, type) => {
    const data = await getArea(id);
    if (type === 'province') {
      //省份
      this.setState({ provinceList: data });
    } else if (type === 'district') {
      this.setState({ districtList: data });
    } else if (type === 'city') {
      this.setState({ cityList: data });
    }
  };

  //获取机构列表
  getInstitutionData = async name => {
    const data = await institutionRecord(name);
    this.setState({ institutionData: data });
  };

  handleOk = e => {
    e.preventDefault();
    const { detailType, institutionInfo } = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const post = {
          institutionName: values.name,
          areaCountry: values.country,
          areaProvince: values.province,
          areaCity: values.city || undefined,
          areaDistrict: values.district,
          feeType: values.feeType,
          status: values.status,
          address: values.address,
          contactNo: values.contactNo,
          contactPerson: values.contactPerson,
          remark: values.remark,
          pid: values.pid,
          installType: values.deployType,
          isDoctorReview: values.reviewType,
          applications: values.application.join(','),
          isTBScreened: values.tbScreened,
          installTime: formatDate(values.installTime),
          installPerson: values.installPerson,
          projectInfo:
            values.projectInfo === undefined ? '' : values.projectInfo,
          drIp: values.drIp,
          sndOrganId: values.sndOrganId,
          radiologyPrice: values.radiologyPrice,
          paymentChannel: values.paymentChannel,
          diagProcessMins: values.diagProcessMins,
        };

        let url, msg;
        if (detailType === 'update') {
          post.id = institutionInfo.id;
          url = apis.modifyinstitution(post);
          msg = '修改成功';
        } else {
          url = apis.addinstitution(post);
          msg = '创建成功';
        }
        url.then(res => {
          if (res.code === '0') {
            message.success(msg);
            this.handleCancel(true);
          }
        });
      }
    });
  };

  //点击“取消按钮”隐藏对话框
  handleCancel = changed => {
    this.props.onCancel(changed);
    this.setState({ visible: false });
  };

  changeCountry = (value, i) => {
    this.props.form.setFieldsValue({
      province: '',
      city: '',
      district: '',
    });
    this.getArea(value, 'province');
  };

  changeProvince = value => {
    this.props.form.setFieldsValue({
      city: '',
      district: '',
    });
    const valueArray = [110000, 120000, 500000, 310000];
    if (valueArray.indexOf(value) >= 0) {
      this.setState({ cityVisible: false });
      this.getArea(value, 'district');
    } else {
      this.setState({ cityVisible: true });
      this.getArea(value, 'city');
    }
  };

  changeCity = value => {
    this.props.form.setFieldsValue({ district: '' });
    this.getArea(value, 'district');
  };

  //省、市、区下拉列表
  getAreaOptions = list => {
    const options = list.map(item => (
      <Option key={item.id} value={item.id}>
        {item.areaName}
      </Option>
    ));
    return options;
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    this.getInstitutionData(value);
  };

  //所属应用下拉菜单
  getProductionOptions = () => {
    const productList = window.store.getState().api.user.info.products;
    if (productList) {
      const options = productList.map(item => (
        <Option key={item.productId}>{i18n.t(item.productName)}</Option>
      ));
      return options;
    }
  };

  render() {
    const { visible, confirmLoading, institutionData } = this.state;
    const { getFieldDecorator } = this.props.form;
    const { institutionInfo, detailType } = this.props;
    const institutionOptions = getInstitutionOptions(institutionData, 'id');
    const formLayout = { labelCol: { span: 8 }, wrapperCol: { span: 13 } };
    const formLayout1 = { labelCol: { span: 4 }, wrapperCol: { span: 20 } };
    const formLayout2 = { labelCol: { span: 0 }, wrapperCol: { span: 24 } };
    const formLayout3 = { labelCol: { span: 11 }, wrapperCol: { span: 13 } };

    let title = '新建机构';
    if (detailType === 'detail') title = '查看机构信息';
    else if (detailType === 'update') title = '修改机构信息';

    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const isDisabled = detailType === 'detail';

    let { projectInfo, isDoctorReview, isTBScreened } = institutionInfo;
    let { applications, installTime } = institutionInfo;
    projectInfo = projectInfo ? parseInt(projectInfo) : undefined;
    isDoctorReview = isDoctorReview ? parseInt(isDoctorReview) : undefined;
    isTBScreened = isTBScreened ? parseInt(isTBScreened) : undefined;
    applications = applications ? applications.split(',') : [];
    installTime = installTime ? moment(installTime, dateFormat) : null;

    const reviewOptions = [
      { label: '未开通', value: 0 },
      { label: '全部审核', value: 1 },
      { label: '肺结核部分审核【0.3阈值】', value: 3 },
      { label: '肺结核部分审核【0.5阈值】', value: 5 },
    ];
    const tbOptions = [
      { label: '开通', value: 1 },
      { label: '不开通', value: 0 },
    ];
    const payOptions = [
      { label: '免费', value: '0' },
      { label: '收费', value: '1' },
    ];
    const statusOptions = [
      { label: '正常', value: 1 },
      { label: '停用', value: 0 },
    ];
    const deployOptions = [
      { label: '云部署', value: 'C' },
      { label: '私有化部署', value: 'P' },
    ];

    const payTypeOptions = [
      { label: '支付宝', value: 1 },
      { label: '微信', value: 2 },
      { label: '银联', value: 3 },
      { label: '其他', value: 9 },
    ];

    return (
      <div className="group-modal">
        <Modal
          title={i18n.t(title)}
          visible={visible}
          width={'50%'}
          height={'60%'}
          className="group-manager"
          onCancel={() => this.handleCancel(false)}
          footer={[
            <Button
              key="cancel"
              onClick={() => this.handleCancel(false)}
              type="default"
              className="btn-cancel"
            >
              {i18n.t('cancel')}
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={confirmLoading}
              onClick={this.handleOk}
              className="btn-ok"
              style={{ display: isDisabled ? 'none' : '' }}
            >
              {i18n.t('ok')}
            </Button>,
          ]}
        >
          <div className="user-add-form">
            <Form {...formLayout}>
              <Row gutter={15}>
                <Col span={12}>
                  <Form.Item label="机构名称" hasFeedback>
                    {getFieldDecorator('name', {
                      rules: [{ required: true, message: '机构名称不能为空' }],
                      initialValue: institutionInfo.institutionName,
                    })(<Input type="text" disabled={isDisabled} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 
                  A类型：该类型机构远程诊断报告需在25分钟内完成并推送给该机构用户
                  B类型：该类型机构远程诊断报告需在45分钟内完成并推送给该机构用户 
                  之前的机构默认为B类45分钟，后期研发新增机构时需确认机构类型
                  */}
                  <Form.Item label="机构类型" hasFeedback>
                    {getFieldDecorator('diagProcessMins', {
                      rules: [{ required: true, message: '机构类型不能为空' }],
                      initialValue: institutionInfo.diagProcessMins || 45,
                    })(
                      <Select>
                        <Option value={25}>A类</Option>
                        <Option value={45}>B类</Option>
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="上级机构" hasFeedback>
                    {getFieldDecorator('pid', {
                      initialValue: institutionInfo.pid,
                    })(
                      <Select
                        showSearch
                        placeholder="请输入机构名称"
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={this.handleInstitutionSearch}
                        notFoundContent={null}
                        disabled={isDisabled}
                        allowClear={true}
                      >
                        {institutionOptions}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="组织机构代码" hasFeedback>
                    {getFieldDecorator('sndOrganId', {
                      initialValue: institutionInfo.sndOrganId,
                    })(<Input disabled={isDisabled} />)}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  {/* 所属项目{接口字段没有定义} */}
                  <Form.Item label="项目名称" hasFeedback {...formLayout1}>
                    {getFieldDecorator('projectInfo', {
                      initialValue: projectInfo,
                    })(
                      <Select allowClear={true} placeholder="选择项目名称">
                        {getProjectOption(this.state.projectList)}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 付费属性 */}
                  <Form.Item label={i18n.t('payType')} hasFeedback>
                    {getFieldDecorator('feeType', {
                      initialValue: institutionInfo.feeType,
                      rules: [{ required: true, message: '付费属性不能为空' }],
                    })(
                      <Select
                        placeholder="选择付费属性"
                        disabled={isDisabled}
                        allowClear={true}
                      >
                        {payOptions.map((item, index) => (
                          <Option key={index} value={item.value}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 状态 */}
                  <Form.Item label={i18n.t('status')}>
                    {getFieldDecorator('status', {
                      initialValue: institutionInfo.status,
                      rules: [{ required: true, message: '账号状态不能为空' }],
                    })(
                      <Radio.Group disabled={isDisabled}>
                        {statusOptions.map((item, index) => (
                          <Radio key={index} value={item.value}>
                            {item.label}
                          </Radio>
                        ))}
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="支付渠道" hasFeedback>
                    {getFieldDecorator('paymentChannel', {
                      initialValue: institutionInfo.paymentChannel,
                    })(
                      <Select disabled={isDisabled} allowClear={true}>
                        {payTypeOptions.map((item, index) => (
                          <Option key={index} value={item.value}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="医疗影像诊断价格" hasFeedback>
                    {getFieldDecorator('radiologyPrice', {
                      initialValue: institutionInfo.radiologyPrice,
                    })(<Input type="text" disabled={isDisabled} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 部署方式 */}
                  <Form.Item label="部署方式" hasFeedback>
                    {getFieldDecorator('deployType', {
                      initialValue: institutionInfo.installType,
                      rules: [{ required: true, message: '部署方式不能为空' }],
                    })(
                      <Select disabled={isDisabled} allowClear={true}>
                        {deployOptions.map((item, index) => (
                          <Option key={index} value={item.value}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 部署方式 */}
                  <Form.Item label="DR IP" hasFeedback>
                    {getFieldDecorator('drIp', {
                      initialValue: institutionInfo.drIp,
                      rules: [
                        {
                          pattern: new RegExp(
                            /((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/g
                          ),
                          message: 'IP格式不正确',
                        },
                      ],
                    })(<Input disabled={isDisabled} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 状态 */}
                  <Form.Item label="开通人工审核">
                    {getFieldDecorator('reviewType', {
                      rules: [
                        { required: true, message: '人工审核方式不能为空' },
                      ],
                      initialValue: isDoctorReview,
                    })(
                      <Select
                        placeholder="是否开通人工审核"
                        disabled={isDisabled}
                      >
                        {reviewOptions.map((item, index) => (
                          <Option
                            key={index}
                            value={item.value}
                            title={item.label}
                          >
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 状态 */}
                  <Form.Item label="开通肺结核筛查">
                    {getFieldDecorator('tbScreened', {
                      rules: [
                        {
                          required: true,
                          message: '开通肺结核筛查不能为空',
                        },
                      ],
                      initialValue: isTBScreened,
                    })(
                      <Radio.Group disabled={isDisabled}>
                        {tbOptions.map((item, index) => (
                          <Radio key={index} value={item.value}>
                            {item.label}
                          </Radio>
                        ))}
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="所属应用" hasFeedback {...formLayout1}>
                    {getFieldDecorator('application', {
                      rules: [{ required: true, message: '所属应用不能为空' }],
                      initialValue: applications,
                    })(
                      <Select
                        mode="multiple"
                        placeholder={i18n.t('applicationPlaceholder')}
                        disabled={isDisabled}
                        onChange={this.handleChange}
                        allowClear={true}
                      >
                        {this.getProductionOptions()}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Row gutter={15}>
                    <Col span={9}>
                      {/* 所在区域 */}
                      <Form.Item label={i18n.t('region')} {...formLayout3}>
                        {getFieldDecorator('country', {
                          rules: [
                            { required: true, message: '所在区域不能为空' },
                          ],
                          initialValue: institutionInfo.areaCountry,
                        })(
                          <Select
                            placeholder={i18n.t('chooseCountry')}
                            onChange={this.changeCountry}
                            disabled={isDisabled}
                            allowClear={true}
                          >
                            <Option value={0}>中国</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item {...formLayout2}>
                        {getFieldDecorator('province', {
                          rules: [{ required: true, message: '省份不能为空' }],
                          initialValue: institutionInfo.areaProvince,
                        })(
                          <Select
                            placeholder={i18n.t('chooseProvince')}
                            onChange={this.changeProvince}
                            disabled={isDisabled}
                            allowClear={true}
                          >
                            {this.getAreaOptions(this.state.provinceList)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    {this.state.cityVisible && (
                      <Col span={5}>
                        <Form.Item {...formLayout2}>
                          {getFieldDecorator('city', {
                            rules: [
                              { required: true, message: '城市不能为空' },
                            ],
                            initialValue: institutionInfo.areaCity,
                          })(
                            <Select
                              placeholder={i18n.t('chooseCity')}
                              onChange={this.changeCity}
                              disabled={isDisabled}
                              allowClear={true}
                            >
                              {this.getAreaOptions(this.state.cityList)}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                    )}

                    <Col span={5}>
                      <Form.Item {...formLayout2}>
                        {getFieldDecorator('district', {
                          rules: [{ required: true, message: '区不能为空' }],
                          initialValue: institutionInfo.areaDistrict,
                        })(
                          <Select
                            placeholder={i18n.t('chooseDistrict')}
                            disabled={isDisabled}
                            allowClear={true}
                          >
                            {this.getAreaOptions(this.state.districtList)}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  {/* 详细地址 */}
                  <Form.Item label="详细地址" hasFeedback {...formLayout1}>
                    {getFieldDecorator('address', {
                      initialValue: institutionInfo.address,
                    })(<Input disabled={isDisabled} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 联系人 */}
                  <Form.Item label={i18n.t('contactperson')} hasFeedback>
                    {getFieldDecorator('contactPerson', {
                      initialValue: institutionInfo.contactPerson,
                    })(<Input disabled={isDisabled} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 联系方式 */}
                  <Form.Item label={i18n.t('contactNo')} hasFeedback>
                    {getFieldDecorator('contactNo', {
                      initialValue: institutionInfo.contactNo,
                    })(<Input disabled={isDisabled} />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 安装时间 */}
                  <Form.Item label="安装时间" hasFeedback>
                    <ConfigProvider locale={zh_CN}>
                      {getFieldDecorator('installTime', {
                        initialValue: installTime,
                        rules: [
                          { required: true, message: '安装时间不能为空' },
                        ],
                      })(
                        <DatePicker
                          showTime
                          placeholder="选择安装时间"
                          disabled={isDisabled}
                        />
                      )}
                    </ConfigProvider>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  {/* 安装人 */}
                  <Form.Item label="安装人" hasFeedback>
                    {getFieldDecorator('installPerson', {
                      initialValue: institutionInfo.installPerson,
                      rules: [{ required: true, message: '安装人不能为空' }],
                    })(<Input disabled={isDisabled} />)}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  {/* 简介 */}
                  <Form.Item label="说明" hasFeedback {...formLayout1}>
                    {getFieldDecorator('remark', {
                      initialValue: institutionInfo.remark,
                    })(<TextArea rows={4} disabled={isDisabled} />)}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(Form.create()(InstitutionAdd));
